import Combobox from '@shared/components/ui/AdvancedFilter/components/Combobox';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface PackagingHeaderProps {
  boxGroupOptions: { label: string; value: string }[];
  boxGroupId: string;
  onBoxGroupIdChange: (value: string) => void;
}

const PackagingHeader: React.FC<PackagingHeaderProps> = ({ boxGroupOptions, boxGroupId, onBoxGroupIdChange }) => {
  const { t } = useTranslation('materialAlmacenModule');

  const boxGroupComboboxOptions = useMemo(
    () => [{ label: t('filter.box_group_all'), value: '' }, ...boxGroupOptions],
    [boxGroupOptions, t],
  );

  return (
    <div className="min-w-0 w-full md:w-52 md:flex-none lg:w-56">
      <Combobox
        options={boxGroupComboboxOptions}
        value={boxGroupId}
        setValue={onBoxGroupIdChange}
        placeholder={t('filter.box_group_placeholder')}
        className="w-full"
        dataTestId="warehouse-material-filter-box-group"
      />
    </div>
  );
};

export default PackagingHeader;
